import runtimeCorePackage from "../package.json" with { type: "json" };

export const OPENSTEER_RUNTIME_CORE_VERSION = runtimeCorePackage.version;
